export default "__VITE_ASSET__BoN33Tvm__"